

import { SubDomain } from "../SubDomain";
import Comment from "./Comment";

export default class CommentsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Comment.MODEL_NAME);
    this.storage = storage;
  }

  findById(objId) {
    var object = this.storage.map[objId];
    return new Comment(this.domain, object);
  }
}